import { Component,OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';
@Component({
  selector: 'app-renewal',
  templateUrl: './renewal.component.html',
  styleUrls: ['./renewal.component.css']
})
export class RenewalComponent implements OnInit{


  renewalForm: FormGroup;
  value: any;
 
  packages = [
    {
      name: 'CUS_HP75Mbps_UL',
      plans: [
        { name: '15 Days', price: 300 },
        { name: '20 Days', price: 450 },
        { name: '30 Days', price: 590 }
      ]
    },
    {
      name: 'CUS_HP100Mbps_UL',
      plans: [
        { name: '15 Days', price: 400 },
        { name: '20 Days', price: 600 },
        { name: '30 Days', price: 750 }
      ]
    },
    {
      name: 'CUS_HP125Mbps_UL',
      plans: [
        { name: '15 Days', price: 500 },
        { name: '20 Days', price: 750 },
        { name: '30 Days', price: 950 }
      ]
    }
  ];

  selectedPlans: any[] = [];
  totalAmount: number = 0;
  newExpiryDate: string = '';

  constructor(private fb: FormBuilder, public location: Location) {
    this.renewalForm = this.fb.group({
      package: [''],
      subPlan: [''],
      comments: ['']
    });
  }

ngOnInit(): void {
  
  this.getUaerPlanDetails();
}

  onPackageChange() {
    const selectedPackage = this.packages.find(
      (pkgs) => pkgs.name === this.renewalForm.value.package
    );

    this.selectedPlans = selectedPackage ? selectedPackage.plans : [];
    this.renewalForm.patchValue({ subPlan: '' });
    this.totalAmount = 0;
  }

  onSubPlanChange(selectedPlanName: string) {
    const selectedPackage = this.packages.find(
      (pkgs) => pkgs.name === this.renewalForm.value.package
    );

    const selectedPlan = selectedPackage?.plans.find(
      (plan) => plan.name === selectedPlanName
    );

    if (selectedPlan) {
      this.totalAmount = selectedPlan.price;

      const days = parseInt(selectedPlan.name.split(' ')[0]);
      if (days) {
        this.calculateExpiryDate(days);
      }
    } else {
      this.totalAmount = 0;
      this.newExpiryDate = '';
    }
  }

  calculateExpiryDate(days: number) {
    const today = new Date();
    today.setDate(today.getDate() + days); // Use selected plan's days
    this.newExpiryDate = today.toISOString().slice(0, 10);
  }


  cancel() {

    this.location.back();
  }


  getUaerPlanDetails() {
    var data: any = new FormData();
    data.append("api_version", "2");
    data.append("client_id", "pmtgw1");
    data.append("ps_key", "3cd4_57b3_9d73_54BB");
    data.append("nas_id", "rlcalcare");
    data.append("action_id", "get_user_id_plan_details");
    data.append("req_params", JSON.stringify({ user_id: "9443438661" }));

    var self = this;
    $.ajax({
      type: "POST",

      url: "https://43.225.167.54:2480/umapi2.php",
      cache: false,
      contentType: false,
      processData: false,
      data: data,

      success: function (result: any) {

        if (result.success == true || result.success == "true") {
          } else {
        }
      }
    });
  }










  

}
